<!--
	Copyright 2023 HALBY
	See LICENSE file for details.
 -->

<script lang="ts">
	import { page } from '$app/stores';
	import { getLang } from '$lib/translations/translations';
	import type { ArtistInfo } from '../../../@types/artist-data';

	export let artistInfo: ArtistInfo;
	export let borderRequired = true;

	let jobColor: string;
	$: {
		switch (artistInfo.meta.job_type) {
			case 'artist':
				jobColor = '#EF9FB9';
				break;
			case 'writer':
				jobColor = '#B9EAAB';
				break;
			case 'other':
				jobColor = '#A7E0F5';
				break;
		}
	}

	let lang: 'ja' | 'zh_cn' | 'zh_tw';
	$: lang = (getLang($page.url).value?.replace('-', '_') || 'ja') as 'ja' | 'zh_cn' | 'zh_tw';
</script>

{#if borderRequired}
	<hr class="job-hr" style="--job-color: {jobColor}"/>
{/if}
<div class="creator-job">
	{#if artistInfo.jobs !== undefined}
		{#each artistInfo.jobs as job}
			<h3 class="job-name font-base-jp font-bold">{job.name[lang]}</h3>
			<div class="skills-wrapper">
				{#each job.skills as skill}
					<div class="skill-label" class:specific={skill.specific}>
						<p class="font-base-jp">{skill.name[lang]}</p>
					</div>
				{/each}
			</div>
		{/each}
	{/if}
	{#if artistInfo.ngs[lang].length !== undefined && artistInfo.ngs[lang].length > 0}
		<h3 class="job-name font-base-jp font-bold">NG</h3>
		{#if artistInfo.ngs !== undefined}
			<div class="skills-wrapper ng-wrapper">
				{#each artistInfo.ngs[lang] as ng}
					<p class="ng-name font-base-jp">・{ng}</p>
				{/each}
			</div>
		{/if}
	{/if}
</div>
{#if borderRequired}
	<hr class="job-hr" style="--job-color: {jobColor}"/>
{/if}

<style lang="scss">
	@use '$lib/assets/css/variables' as var;

	.job-hr {
		border: none;
		height: 6px;
		margin: 30px 0;
		background-color: var(--job-color);
	}
	h3 {
		// font-family: var.$font-base;
		color: var.$color-font-base;
		margin: 20px 0;
		font-size: 20px;
	}
	.skills-wrapper {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
	}
	.skill-label {
		padding: 5px 20px;
		border-radius: 9999px;
		background-color: var.$color-light-bg-grey;
		border: 1px solid var.$color-border-grey;
		p {
			// font-family: var.$font-base;
			font-size: 12.8px;
			font-weight: 400;
			color: var.$color-dark-brown;
			letter-spacing: 1.6px;
		}
		&.specific {
			background-color: var.$color-accent-yellow;
		}
	}
	.ng-wrapper {
		display: flex;
		flex-direction: column;
	}
	.ng-name {
		color: var.$color-dark-brown;
	}
</style>
